import React from 'react';
import { IonGrid, IonRow, IonCol, IonCard, IonIcon, IonCardContent } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import { useHistory } from 'react-router-dom';
import svgChat from '../../assets/images/icons/dashboard/chatIcon.svg';
import svgDocumentsUpload from '../../assets/images/icons/dashboard/documentsupload.svg';
import svgPrescription from '../../assets/images/icons/dashboard/pre.svg';
import svgMedicine from '../../assets/images/icons/dashboard/med.svg';
import svgSOSContact from '../../assets/images/icons/dashboard/soscontact.svg';
import svgCalendar from '../../assets/images/icons/dashboard/calendar.svg';
import svgSafety from '../../assets/images/icons/dashboard/safetyrules.svg';
import svgBracelet from '../../assets/images/icons/dashboard/bracelet.svg';
import svgYouTube from '../../assets/images/youtube.svg';
import svgFirstAid from '../../assets/images/firstAid.svg';
import svgWoman from '../../assets/images/womanCalendar.svg';
import svgPDFSeizure from '../../assets/images/downloadSeizurePDF.svg';
import svgLogo from '../../assets/images/logoEpi.svg';
import svgSeizure from '../../assets/images/icons/dashboard/seizure.svg';
import styles from './Dashboard.module.scss';
import { useDetermineWomenCalendarNavItem } from '../../hooks/useDetermineWomenCalendarNavItem';
import { useAuth } from '../../contexts/auth-context';
import { AppPage } from '../../routes/Router';
import { useToggleState } from '../../hooks/useToggleState';
import { Review } from '../../pages/app-review/Review';

const cx = classNames.bind(styles);

const appPages: AppPage[] = [
  {
    id: 1,
    icon: svgPrescription,
    iconStyle: styles.purple,
    title: 'Multiplicity and dosage of taking PEP',
    url: '/prescriptions',
    description: 'some text',
  },
  {
    id: 2,
    icon: svgSeizure,
    iconStyle: styles.green,
    title: 'Record a seizure',
    url: '/seizures',
    description: 'some text',
  },
  {
    id: 3,
    icon: svgSOSContact,
    iconStyle: styles.green,
    title: 'SOS Contacts',
    url: '/sos-contacts',
    description: 'some text',
  },
  {
    id: 4,
    icon: svgMedicine,
    iconStyle: styles.cyan,
    title: 'PEP stock control',
    url: '/medicines',
    description: 'some text',
  },
  {
    id: 5,
    icon: svgCalendar,
    iconStyle: styles.pink,
    title: 'Seizure statistic',
    url: '/calendar',
    description: 'some text',
  },
  {
    id: 6,
    icon: svgYouTube,
    iconStyle: styles.lgGreen,
    title: 'Video instruction on YouTube',
    url: 'https://www.youtube.com/user/epihelperl',
    description: 'some text',
  },
  {
    id: 7,
    icon: svgSafety,
    iconStyle: styles.antiquebrass,
    title: 'Safety rules',
    url: 'https://xn--e1aahnrdi9a7d.xn--p1ai/',
    description: 'some text',
  },
  {
    id: 8,
    icon: svgFirstAid,
    iconStyle: '',
    title: 'First aid for a seizure',
    url: 'https://xn--e1aahnrdi9a7d.xn--p1ai/',
    description: 'some text',
  },
  {
    id: 9,
    icon: svgWoman,
    iconStyle: styles.antiquebrass,
    title: "Women's calendar",
    url: '/women-calendar',
    description: 'some text',
  },
  {
    id: 10,
    icon: svgPDFSeizure,
    iconStyle: styles.antiquebrass,
    title: 'Download seizure calendar',
    url: '/calendar',
    description: 'some text',
  },
  {
    id: 11,
    icon: svgBracelet,
    iconStyle: styles.turmeric,
    title: 'Buy a bracelet',
    url: 'https://epihelper.com/',
    description: 'some text',
  },
  {
    id: 12,
    icon: svgLogo,
    iconStyle: styles.antiquebrass,
    title: 'Helping project',
    url: '',
    description: 'some text',
  },
  {
    id: 13,
    icon: svgChat,
    iconStyle: styles.antiquebrass,
    title: 'Chat with doctor',
    url: '/chat',
    description: 'some text',
  },
  {
    id: 14,
    icon: svgDocumentsUpload,
    iconStyle: styles.antiquebrass,
    title: 'Documents upload',
    url: '/patient-files',
    description: 'some text',
  },
];

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [showReviewModal, toggleShowReviewModal] = useToggleState(false);
  const authContext = useAuth();
  const { menuItems } = useDetermineWomenCalendarNavItem(appPages, authContext);

  return (
    <IonGrid className={cx('DashboardContainer')}>
      {showReviewModal && <Review onDismiss={toggleShowReviewModal} />}
      <IonRow>
        {menuItems.map((appPage) => (
          <IonCol key={appPage.id} size="6" sizeMd="4" className={cx('DashboardContainer__col')}>
            <IonCard
              className={cx('DashboardContainer__card')}
              onClick={() => {
                if (appPage.id === 12) {
                  toggleShowReviewModal();
                } else if (appPage.id === 10) {
                  push({
                    pathname: appPage.url,
                    search: '?downloadPDF=true',
                  });
                } else {
                  const openOrPushPage = appPage.url.includes('http') ? window.open : push;
                  openOrPushPage(appPage.url);
                }
              }}
            >
              <div className={cx('DashboardContainer__card-header')}>
                <IonIcon className={cx(appPage.iconStyle, 'DashboardContainer__card-headerIcon')} src={appPage.icon} />
              </div>
              <IonCardContent className={cx('DashboardContainer__card-content')}>
                <div className={cx('DashboardContainer__card-contentTitle')}>{t(appPage.title)}</div>
              </IonCardContent>
            </IonCard>
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>
  );
};

export { Dashboard };
